import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    activityId: null,
    documentId: null,
    courseId: null,
    linkCardData: [
      {
        category: "Chemistry",
        color: "#e2f4fd",
        links: [
          {
            title: "TITRATION",
            thumbnailLink: "titration.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/titration/",
            dsc: "Use a reagent to determine the concentration of a known substance",
            maintnance: false,
            update: false
          },
          {
            title: "FLAME TEST",
            thumbnailLink: "flame_test.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/flame_test/",
            dsc: "Identify metal ions using their emission spectra",
            maintnance: false,
            update: false
          },
          {
            title: "CALORIMETRY: ALCOHOL",
            thumbnailLink: "calorimetry.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/calorimetry/",
            dsc: "Determine the energy released during combustion reactions",
            maintnance: false,
            update: false
          },
          {
            title: "CALORIMETRY: FOOD",
            thumbnailLink: "calorimetry_food.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/calorimetry_food/",
            dsc: "Determine the energy released during combustion reactions",
            maintnance: false,
            update: false
          },
          {
            title: "CHEMICAL TESTS",
            thumbnailLink: "chemical_tests.png",
            link: "https://students.open.ac.uk/candc/open_stem_africa/chemical_tests/",
            dsc: "Identify common ions in aqueous solutions by using appropriate reagents",
            maintnance: false,
            update: false
          },
          {
            title: "RATES OF REACTION",
            thumbnailLink: "rates_of_reaction.png",
            link: "",
            dsc: "Monitor the speed of chemical reactions",
            maintnance: true,
            update: false
          }
        ]
      }
    ]
  },
  mutations: {
    SET_ACTIVITY_ID(state, payload) {
      state.activityId = payload;
    },
    SET_DOCUMENT_ID(state, payload) {
      state.documentId = payload;
    },
    SET_COURSE_ID(state, payload) {
      state.courseId = payload;
    }
  },
  actions: {
    setActivityId({
      commit
    }, payload) {
      commit("SET_ACTIVITY_ID", payload);
    },
    setDocumentId({
      commit
    }, payload) {
      commit("SET_DOCUMENT_ID", payload);
    },
    setCourseId({
      commit
    }, payload) {
      commit("SET_COURSE_ID", payload);
    }
  }
});